<template>
  <div>
  <DeletedKokuban
    :kokubanDataList="kokubanDataList"
    :currentConstruction="currentConstruction"
    @reloadKokubanDataList="reloadKokubanDataList($event)" />
  </div>
</template>

<script>
import store from '@/store'

// 黒板リストの初期化
const initKokubanDataList = async (cloudConstructionId) => {
  const args = {
    cloud_construction_id: cloudConstructionId,
    is_deleted_only: true
  };
  const apiResult = await store.dispatch('api/getKokubanDataList', args)
  if (store.getters['api/apiError']) {
    return false;
  }
  const aws_args = {
    cloud_construction_id: cloudConstructionId,
    kokubandata_list: apiResult
  }
  await store.dispatch('aws/kokubanDataListOf', aws_args)
  if (store.getters['api/apiError']) {
    return false;
  }
  return true;
}

export default {
  name: 'KokubanOutput',
  components: {
    DeletedKokuban: () => import('@/components/cloud/CreKokuban/ConstructionFolder/DeletedKokuban.vue')
  },
  props: {
    currentConstruction: Object
  },
  computed: {
    kokubanDataList() {
      // awsからの取得結果を返す
      // TODO この curKokubanDataList、（通常の黒板のほうと）共有できるだろうか？
      return this.$store.getters['aws/result/curKokubanDataList'];
    }
  },
  beforeRouteEnter(to, from, next) {
    // 黒板リスト取得
    initKokubanDataList(to.params.cloudConstructionId).then(inintResult => {
      if(!inintResult){
        next(false);
        return;
      }
      next();
    })
  },
  methods: {
    reloadKokubanDataList({ cloudConstructionId, done }){
      initKokubanDataList(cloudConstructionId).then(() => {
        done();
      })
    }
  }
}
</script>

<style scoped>
</style>